import React from 'react';
import { Page } from '../Page';
import { Beef, Carrot, Wheat } from 'lucide-react';
export function Page5b() {
  return <Page pageNumber={24} variant="light" data-id="element-542">
      <div className="flex flex-col h-full" data-id="element-543">
        <div className="mb-8 pt-4" data-id="element-544">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-545">
            Practical Tools
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-546">
            The Fist <span className="text-tealslate" data-id="element-547">Method</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-548" />
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-10 max-w-lg" data-id="element-549">
          If you are eating out, traveling, or just don't want to think about
          fractions of a plate, use your hand. It's scaled to your body size and
          always with you.
        </p>

        <div className="space-y-6 mb-10" data-id="element-550">
          <div className="flex items-start gap-5 bg-[#EAEAE4] border border-[#D8D8D0] p-6" data-id="element-551">
            <div className="w-12 h-12 rounded-full bg-tealslate flex items-center justify-center shrink-0" data-id="element-552">
              <Beef className="w-6 h-6 text-white" data-id="element-553" />
            </div>
            <div data-id="element-554">
              <h2 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-555">
                Protein = Palm of Your Hand
              </h2>
              <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-556">
                A portion of meat, fish, or poultry should be roughly the size
                and thickness of your palm (about 3-4 oz or 20-30g of protein).
              </p>
            </div>
          </div>

          <div className="flex items-start gap-5 bg-[#EAEAE4] border border-[#D8D8D0] p-6" data-id="element-557">
            <div className="w-12 h-12 rounded-full bg-navyslate flex items-center justify-center shrink-0" data-id="element-558">
              <Carrot className="w-6 h-6 text-white" data-id="element-559" />
            </div>
            <div data-id="element-560">
              <h2 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-561">
                Vegetables = Your Fist
              </h2>
              <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-562">
                Aim for at least one fist-sized portion of non-starchy
                vegetables with lunch and dinner.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-5 bg-[#EAEAE4] border border-[#D8D8D0] p-6" data-id="element-563">
            <div className="w-12 h-12 rounded-full bg-bluegray flex items-center justify-center shrink-0" data-id="element-564">
              <Wheat className="w-6 h-6 text-white" data-id="element-565" />
            </div>
            <div data-id="element-566">
              <h2 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-567">
                Carbs = Cupped Hand
              </h2>
              <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-568">
                A portion of rice, potatoes, pasta, or fruit should fit into
                your cupped hand.
              </p>
            </div>
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-end" data-id="element-569">
          <p className="text-xs text-[#3B3B3B] leading-[1.8] mb-6 italic text-center" data-id="element-570">
            <strong className="text-tealslate" data-id="element-571">Important:</strong> On GLP-1
            medication, always eat your protein first. You may not finish
            everything on your plate, and that is perfectly fine.
          </p>

          {/* Stat Bar */}
          <div className="flex w-full h-16 text-white text-xs font-bold uppercase tracking-wider" data-id="element-572">
            <div className="flex-1 bg-tealslate flex items-center justify-center border-r border-[#F5F5F0]" data-id="element-573">
              Palm = 20-30g Protein
            </div>
            <div className="flex-1 bg-navyslate flex items-center justify-center border-r border-[#F5F5F0]" data-id="element-574">
              Fist = 1 cup Veggies
            </div>
            <div className="flex-1 bg-bluegray flex items-center justify-center" data-id="element-575">
              Cup = 1/2 cup Carbs
            </div>
          </div>
        </div>
      </div>
    </Page>;
}